export const css = {
    root: '_2NwxsYZP',
    active: 'bPgNGAZY',
    selected: '_1gfGjRvB',
    disabled: '_209BQuj9',
    ' _key': 'afcpe-theme/dojo/list-item'
};
export default css;
